export const emailValidation = (email: string) => {
   const regex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);

   if(email.length > 0 && email.match(regex)) {
      return true
   } else {
      return false
   }
};

export const passwordValidation = (password: string) => {
   const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*=?])[A-Za-z\d!@#$%^&*=?]{8,16}$/;

   if(password.length > 7 && password.match(regex)) {
      return true
   } else {
      return false
   }
};

export const isNumeric = (str: string | undefined): boolean => {
  if (str) {
    return /^\d+$/.test(str);
  }
  return false
};